/* global $ */

"use strict";
/**
 * initializes modal events
 * @param {string} pid product ID
 * @param {addStuffCallback} callback - A callback to run.
 * @returns {void}
 */
function getBisInfo(pid, callback) {
    var bisInfoUrl = $("#bis-button-data").data("url");
    if (pid) {
        bisInfoUrl = bisInfoUrl + "?pid=" + pid;
    }

    $.ajax({
        method: "GET",
        url: bisInfoUrl,
        dataType: "json",
        success: function (resp) {
            if (resp) {
                callback(resp);
            }
        }
    });
}
/**
 * submits back in stock request
 *
 * @param {string} pid - product ID
 * @param {string} email - subscriber email
 * @param {string} url - url
 * @param {string} csrfToken - csrf token
 * @returns {void}
 */
function subscribeForBackInStock(pid, email, url, csrfToken) {
    var queryString = "?pid=" + pid + "&action=subscribe";
    queryString += "&csrf_token=" + csrfToken;
    $.ajax({
        method: "GET",
        url: url + queryString,
        dataType: "json",
        data: {
            email: encodeURI(email)
        },
        success: function (data) {
            setTimeout(function () {
                $("#bis-subscription").empty();
                $(".bis-subscription__message").html(data.msg);
                $("a.bis-trigger").addClass("disabled").attr("disabled", true);
                $("button.notify-me-btn").removeClass("active").addClass("disabled").attr("disabled", true);
            }, 1000);
        },
        error: function (error) {
            if (error.status === 200) {
                setTimeout(function () {
                    $("button.notify-me-btn").removeClass("active");
                    $("#bis-subscription").empty();
                    $(".bis-subscription__message").html(data.msg);
                }, 1000);
            }
        }
    });
}

/**
 * initializes modal events
 * @param {string} url - url
 * @returns {void}
 */
function initModalEvents(url) {
    $("#backinstockform").submit(function (e) {
        e.preventDefault();
        var $form = $("#backinstockform");
        var $email = $form.find("input[name=\"email\"]");
        var pid = $form.find("input[name=\"productID\"]").val();
        var csrfToken = $form.find("input[name=\"csrf_token\"]").val();

        if (pid && $email.val) {
            subscribeForBackInStock(pid, $email.val(), url, csrfToken);
        }
    });
}

/**
 * loads back in stock modal
 *
 * @param {string} productID - product ID
 * @param {string} handleBackinstockUrl - subscription url
 * @returns {void}
 */
function loadBackInStockModal(productID, handleBackinstockUrl) {
    var queryString = "?pid=" + productID + "&action=modal";
    var url = handleBackinstockUrl + queryString;
    $.spinner().start();
    $.ajax({
        method: "GET",
        url: url,
        dataType: "html",
        success: function (resp) {
            if (resp) {
                $("#bis-subscription").empty().html(resp);
                $.spinner().stop();
                initModalEvents(handleBackinstockUrl);
                $("#customeremail").on("keyup", validateBISForm);
                $("#process-customer-data").on("change", validateBISForm);
            }
        },
        error: function () {
            $.spinner().stop();
        }
    });
}
/**
 * init the notify button
 * @returns {void}
 */
function initAtcButtons() {
    var atcButtons = $(".add-to-cart, .add-to-cart-global").filter(":not(.bis-trigger)");
    atcButtons.each(function () {
        var atcButton = $(this);
        if (atcButton.hasClass("add-to-cart")) {
            atcButton.data("atc-class", "add-to-cart");
        } else {
            atcButton.data("atc-class", "add-to-cart-global");
        }
        atcButton.data("atc-inner", atcButton.html());
    });
}
/**
 * update the pdp
 * @param {Object} e event
 * @param {Object} response call response
 * @returns {void}
 */
function updatePDP(e, response) {
    var atcButton = $(e.target);
    var url = $("a.bis-trigger").data("url");

    $("a.bis-trigger").removeClass("disabled").attr("disabled", false);
    $("button.notify-me-btn").removeClass("disabled").attr("disabled", false);
    $(".bis-subscription__message").empty();


    if (atcButton.hasClass("btn-update-wishlist-product")) {
        return;
    }

    if (response.product.id) {
        atcButton.data("bis-pid", response.product.id);
    }

    var pid = atcButton.data("bis-pid");
    getBisInfo(pid, function (resp) {
        if (resp.bisEnabled && !resp.productInStock && resp.hasStockRecord && !resp.hideAddToCart) {
            $(".add-to-cart").css("display", "none");
            $("a.bis-trigger").css("display", "block");
            if (resp.subscribed) {
                $("a.bis-trigger").addClass("disabled").attr("disabled", true);
                $("button.notify-me-btn").addClass("disabled").attr("disabled", true);
                $("#bis-subscription").empty();
                $(".bis-subscription__message").html(resp.subscribedMsg);
            } else {
                $("a.bis-trigger").attr("href", url + pid).find(".notify-me-btn").data("pid", pid);
            }
        } else {
            $(".add-to-cart").css("display", "block");
            $("a.bis-trigger").css("display", "none");
        }
        if (resp.bisEnabled && resp.productOrderable) {
            var messageWrapper = $(".limit-stock-info");
            messageWrapper.remove();

            if (resp.limitMsg) {
                messageWrapper = $("<div class=\"limit-stock-info\">" + resp.limitMsg + "</div>");
                $(".product-availability").append(messageWrapper);
            }
        }
    });
}

/**
 * Intializes add to cart / notify me CTA on PDP
 */
function initPDP() {
    var $atcButton = $("a.bis-trigger");
    var url = $atcButton.data("url");
    var pid = $atcButton.find(".notify-me-btn").data("pid");
    var readyToOrder = $atcButton.data("ready-to-order");
    var available = $atcButton.data("available");

    if ($atcButton.find(".notify-me-btn").hasClass("btn-update-wishlist-product")) {
        return;
    }

    getBisInfo(pid, function (resp) {
        if ($atcButton.find(".notify-me-btn").hasClass("wishList-btn") && !resp.productInStock && resp.bisEnabled) {
            $atcButton.hide();
            $atcButton.siblings(".outOfStockText").show();
        }

        if (resp.bisEnabled && (readyToOrder && readyToOrder !== undefined) && !resp.productInStock && resp.hasStockRecord && !available) {
            $(".add-to-cart").css("display", "none");
            $("a.bis-trigger").css("display", "block");
            if (resp.subscribed) {
                $("a.bis-trigger").addClass("disabled").attr("disabled", true);
                $("button.notify-me-btn").addClass("disabled").attr("disabled", true);
                $("#bis-subscription").empty();
                $(".bis-subscription__message").html(resp.subscribedMsg);
            } else {
                $("a.bis-trigger").attr("href", url + pid).find(".notify-me-btn").data("pid", pid);
            }
        } else {
            $(".add-to-cart").css("display", "block");
            $("a.bis-trigger").css("display", "none");
        }

        if (resp.bisEnabled && resp.productOrderable && resp.limitMsg) {
            var messageWrapper = $(".limit-stock-info");
            messageWrapper.remove();
            messageWrapper = $("<div class=\"limit-stock-info\">" + resp.limitMsg + "</div>");
            $(".product-availability").append(messageWrapper);
        }
    });
}

/**
 * Intializes wishlist update
 */
function handleWishlistUpdate() {
    if ($(".wishList-btn").length) {
        var x = new MutationObserver(function (e) {
            if (e[0].addedNodes) {
                initAtcButtons();
                initPDP();
            }
        });
        x.observe($(".wishlistItemCards")[0], { childList: true });
    }
}
/**
 * create wrapper modal
 *
 * @retutns {void}
 */
function createModalWrapper() {
    $("body").append(
        $("<div/>")
            .attr("id", "backinstockmodal")
            .attr("role", "dialog")
            .addClass("modal fade")
    );
}

/**
 * Back in stock interface events hadler
 *
 * @retutns {void}
 */
function bisEventsHandler() {
    getBisInfo(null, function (resp) {
        if (resp.bisEnabled && !$("#backinstockmodal").length) {
            createModalWrapper();
        }
    });

    /**
         * Hadles events on CTA and swatches
         *
         * @param {Object} addToCart - add to cart CTA
         * @returns {void}
         */
    function elEvents(addToCart) {
        addToCart.mouseout(function () {
            if (addToCart.hasClass("button-cart-mailmeback")) {
                addToCart.addClass(addToCart.data("atc-class"));
            }
        });

        addToCart.mouseover(function () {
            if (addToCart.hasClass("button-cart-mailmeback")) {
                addToCart.removeClass(addToCart.data("atc-class"));
            }
        });
    }
    $("body").on("shown.bs.modal", function () {
        initAtcButtons();
        getBisInfo(null, function (resp) {
            if (resp.bisEnabled && !$("#backinstockmodal").length) {
                createModalWrapper();
            }
        });
        initPDP();
        elEvents($(".bis-trigger"));
    });

    elEvents($(".bis-trigger"));

    $("body").on("click", ".bis-trigger", function (e) {
        e.preventDefault();

        const $btn = $(e.target);
        const pid = $btn.data("pid");

        $btn.addClass("active");
        
        if (pid) {
            getBisInfo(null, function (resp) {
                loadBackInStockModal(pid, resp.bisFormUrl);
            });
        }
    });
}

function validateBISForm() {
    var isEmail = $("#customeremail").val().length;
    var isPrivatPolicy= $("#process-customer-data").is(":checked");

    if (isEmail > 0 && isPrivatPolicy) {
        $("#backinstockButton").removeClass("disabled").attr("disabled", false);
    } else {
        $("#backinstockButton").addClass("disabled").attr("disabled", true);
    }
}

module.exports = {
    initializeEvents: function () {
        getBisInfo(null, function (resp) {
            if (resp.bisEnabled) {
                initAtcButtons();
                initPDP();
                handleWishlistUpdate();
                $("body").on("product:updateAddToCart", updatePDP);
                bisEventsHandler();
            }
        });
    }
};
